export default "__VITE_ASSET__7e099cc1__"